module.exports = __webpack_public_path__ + "img/cert6.58cd7e7b.png";